import { z } from 'zod';
import { dateInInterval } from '../global.validation';

export const ppmMilestoneDraftValidationSchema = (minDate?: Date) =>
  z.object({
    realisationEnvisagees: z
      .string()
      .min(1, 'Le champ "realisation envisagees" ne doit pas être vide')
      .max(250, 'ce champ ne doit pas dépasser 250 caractères.'),
    'typeMarcher.id': z.number({ required_error: 'Le type de marché est obligatoire' }).min(1, 'Le type de marché ne doit pas être vide'),
    beneficiaire: z
      .string({
        required_error: 'Le bénéficiaire est obligatoire',
      })
      .optional(),
    'modePassation.id': z.number({ required_error: 'Le mode de sélection est obligatoire' }).min(1, 'Le mode de sélection ne doit pas être vide'),
    datePrevAc: dateInInterval({
      invalid_type_error: "La date prévue d'attribution du contrat est obligatoire",
      required_error: "La date prévue d'attribution du contrat est obligatoire",
      min: minDate,
    }),
    datePrevLps: dateInInterval({
      invalid_type_error: 'La date à laquelle le processus de sélection devrait commencer est obligatoire',
      required_error: 'La date à laquelle le processus de sélection devrait commencer est obligatoire',
      min: minDate,
    }),
    datePrevDp: dateInInterval({
      invalid_type_error: '',
      required_error: 'La date prévue de démarrage des prestations est obligatoire',
      min: minDate,
    }),
    datePrevAp: dateInInterval({
      invalid_type_error: '',
      required_error: "La date prévue d'achèvement ou de livraison du projet est obligatoire",
      min: minDate,
    }),
  });

export const ppmMilestoneFloawableValidationSchema = (minDate?: Date) =>
  ppmMilestoneDraftValidationSchema(minDate)
    .refine(d => d.datePrevLps < d.datePrevAc, {
      message: "La date d'attribution doit précéder la date de lancement du processus",
      path: ['datePrevAc'],
    })
    .refine(d => d.datePrevLps < d.datePrevDp, {
      message: 'La date de lancement doit précéder la date de démarrage des prestations',
      path: ['datePrevDp'],
    })
    .refine(d => d.datePrevDp < d.datePrevAp, {
      message: "La date de démarrage doit précéder la date d'achèvement",
      path: ['datePrevAp'],
    });

export const ppmMilestoneFundingValidationSchema = z.object({
  sourceFinancement: z.object({
    id: z.number({ required_error: 'Le type de financement est obligatoire' }).min(1, 'Le type de financement ne doit pas être vide'),
  }),
  monnaieId: z.number({ required_error: 'Le type de monnaie est obligatoire' }).min(1, 'Le type de monnaie ne doit pas être vide'),
  budgetEstimer: z.number({
    required_error: 'Le budget doit être renseigné',
  }),
});

export const ppmMilestoneSlotsValidationSchema = z.object({
  description: z
    .string({ required_error: 'Le lot ne doit pas être vide' })
    .min(1, 'Le lot ne doit pas être vide')
    .max(250, 'ce champ doit faire moins de 250 caractères'),
  budget: z
    .number({
      required_error: 'Le budget doit être renseigné',
    })
    .optional(),
});
